export const routes = (prefix = `dashboard`) => [
    {
        name: `${prefix}.dashboard.index`,
        path: `/${prefix}/dashboard`,
        component: () => import('./Home.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.home-dashboard.index`,
                PageDescription: "Home - Main DashBoard",
            },
        },
    },
];
